import { Component, Element, Prop, h } from '@stencil/core';

import { onCertificateInit } from '../actions/actions.certificate';
import { onConsumerMarketConfidenceInit } from '../actions/actions.consumer-market-confidence';
import { onCounterofferInit } from '../actions/actions.counteroffer';
import { onFireDREvent } from '../actions/actions.offer';
import { state as autoCheckState, on as onAutoCheck } from '../store/store.autocheck';
import { state as consumerMarketConfidenceState } from '../store/store.consumer-market-confidence';
import { state as counterofferState } from '../store/store.counteroffer';
import { state as customerState, on as onCustomer } from '../store/store.customer';
import { state as dealerState, on as onDealer } from '../store/store.dealer';
import { state as funnelComponentState } from '../store/store.funnel-component';
import { state as kelleyBuysYourCarOfferState } from '../store/store.kelley-buys-your-car-offer';
import { state as offerState, on as onOffer } from '../store/store.offer';
import { state as offerVehicleState, on as onOfferVehicle } from '../store/store.offer-vehicle';
import { state as optimizelyState } from '../store/store.optimizely';

@Component({
  tag: 'ico-certificate-hydrator',
  shadow: true,
})
export class IcoCertificateHydrator {
  @Prop() entry: string = '';
  @Prop() offerId: string = '';
  @Prop() prospectId: string = '';
  @Prop() offerCode: string;
  @Prop() lnxCode: string;
  @Prop() utmSource: string = 'app';
  @Prop() isAdmin = false;
  @Prop() theme: string;
  @Prop() category: string;
  @Prop() canEditMileageIneligible = false;
  @Prop() minimumMileageIneligibleThreshold: number = 0;
  @Prop() dealerName: string = '';
  @Prop() showKelleyBuysYourCar = false;

  @Element() el: HTMLElement;

  async componentWillLoad() {
    await onCertificateInit(
      this.offerId,
      this.entry,
      this.offerCode,
      this.lnxCode,
      this.utmSource,
      this.isAdmin,
      this.category,
      this.canEditMileageIneligible,
      this.minimumMileageIneligibleThreshold,
      this.prospectId,
      this.dealerName,
      this.showKelleyBuysYourCar
    );
    onCounterofferInit();
    onConsumerMarketConfidenceInit();

    // boostrap props
    this.setupStateProps();
    onAutoCheck('set', this.updateChildrenProps);
    onCustomer('set', this.updateChildrenProps);
    onDealer('set', this.updateChildrenProps);
    onOffer('set', this.updateChildrenProps);
    onOfferVehicle('set', this.updateChildrenProps);
  }

  updateChildrenProps = (prop, value) => {
    this.el.childNodes.forEach((element) => {
      element[prop] = value;
    });
  };
  // explicitly declare initial state props
  setupStateProps() {
    this.el.childNodes.forEach((element) => {
      element['autoCheck'] = autoCheckState;
      element['customer'] = customerState;
      element['dealer'] = dealerState;
      element['offer'] = offerState;
      element['vehicle'] = offerVehicleState;
      element['optimizely'] = optimizelyState;
      element['theme'] = this.theme;
      element['isAdmin'] = this.isAdmin;
      element['acceptOrCounteroffer'] = counterofferState;
      element['consumerMarketConfidence'] = consumerMarketConfidenceState;
      element['kelleyBuysYourCarOffer'] = kelleyBuysYourCarOfferState;
      element['funnelComponent'] = funnelComponentState;
      element['onFireDREvent'] = onFireDREvent;
    });
  }

  render() {
    return (
      <div class="hydration-container hydration-container--cert">
        <slot />
      </div>
    );
  }
}
